import React from 'react'
import ArticleAnalysisChart from './ArticleAnalysisChart'
import ProcessChart from './ProcessChart'

const HowWeRollSection = () => {
  return (
    <>
      <div className='mb-10'>
        <div className='p-6'>
          <div className='text-5xl md:text-6xl font-bold mb-4'>How we roll?</div>
          <div className='mb-6'>
            <div className='text-xl tracking-wide'>
              Our custom built <span className='font-bold'>NLP/AI-Context Mapping Engine</span> does it all. Our{' '}
              <span className='font-bold'>JS tag</span> communicates with our ad servers ensuring that readers receive
              the ad content from our servers <span className='font-bold'>Securely</span>. The tag shows the ad based on{' '}
              <span className='font-bold'>user's interaction</span> and{' '}
              <span className='font-bold'>keyword's position</span> on the current page.
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 items-center'>
              <ul className='grid grid-cols-1 gap-4 p-4 font-light tracking-wider'>
                <li className='text-right'>Which contextual hints are available on this article?</li>
                <li>Which ad campaigns would be most profitable?</li>
                <li className='text-right'>
                  Which contextual hint should the <span className='font-semibold'>Ad</span> appear on?
                </li>
              </ul>
              <div className='flex items-center justify-center'>
                <ArticleAnalysisChart />
              </div>
            </div>
          </div>
          <div className='flex items-center justify-center'>
            <ProcessChart />
          </div>
        </div>
      </div>
      <div className='text-xl uppercase tracking-wider text-center'>Best part, it doesn't even need cookies!</div>
    </>
  )
}

export default HowWeRollSection
